import { FC } from "react"
const Nav:FC = () => {
  return (
    <div className='bg-blue-900 text-white text-2xl p-4'>Any Hub</div>
  )
}
export default Nav